
import Vue from 'vue';
import App from './App.vue';
import store from "@/store"
import { Dialog, Input, Button } from 'element-ui';

// 注册vue指令
import "./directive/index"

Vue.use(Dialog)
Vue.use(Input)
Vue.use(Button)
Vue.config.productionTip = false;
new Vue({
  render: (h) => h(App),
  store
}).$mount("#app");




